<template>
  <section class="ViewHowCards">
    <div class="ViewHowCards__row">
      <div class="ViewHowCards__col">
        <div class="app-it-advantage">
          <div class="app-it-advantage__title app-it-advantage__title--large">
            Безопасная сделка
          </div>
          <div class="app-it-advantage__desc">
            Покупатель вносит предоплату на номинальный счет, деньги хранятся
            там до тех пор пока не будут выполнены условия договора по сделке.
            Поставщик получит оплату после отгрузки.
            <br />
            <router-link to="/safe-transaction"
              >Как купить по безопасной сделке</router-link
            >
          </div>
        </div>
      </div>
      <div class="ViewHowCards__col">
        <div class="app-it-advantage">
          <div class="app-it-advantage__title app-it-advantage__title--large">
            Целевой кредит на топливо
          </div>
          <div class="app-it-advantage__desc">
            Интеграция с крупнейшими банками. Покупая топливо, можно оформить
            целевой кредит на выгодных условиях до 150 млн рублей.
            <br />
            <router-link to="/about-credits">Подробнее о кредите</router-link>
          </div>
        </div>
      </div>
      <div class="ViewHowCards__col">
        <div class="app-it-advantage">
          <div class="app-it-advantage__title app-it-advantage__title--large">
            Доставка
          </div>
          <div class="app-it-advantage__desc">
            Доставка автотранспортом поставщика высокопрофессиональными
            водителями, строго соблюдающие требования ДОПОГ. Проводится
            предварительная оценка соответствия ГОСТ. Возможен самовывоз.<br />
            <router-link to="/offers/item/1882"
              >Рассчитать с доставкой</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ViewHowCards',
};
</script>

<style lang="scss"></style>
